import React, { FunctionComponent } from 'react';

import styles from './NoResultsOption.scss';

type NoResultsOptionProps = {
    children: React.ReactNode;
    dataTn?: string;
};

export const NoResultsOption: FunctionComponent<NoResultsOptionProps> = ({ children, dataTn }) => {
    return (
        <div className={styles.noResults} data-tn={dataTn}>
            {children}
        </div>
    );
};
